import $ from 'jquery';

class API {
  constructor() {
    this.urlBase = 'https://events360.co.uk/';
    this.apiBase = this.urlBase + 'api/api/';
    this.standardTimeout = 30 * 1000;
  }

  competitors(data, done, notFound, fail) {
    var url = this.apiBase +
      'competitors/?event_id=' + encodeURIComponent(data.event_id);

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data.competitors);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  checkpoints(data, done, notFound, fail) {
    var url = this.apiBase +
      'checkpoints/?event_id=' + encodeURIComponent(data.event_id) + "&temp=1";

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  getevent(event_id, done, notFound, fail) {
    var url = this.apiBase +
      'events/?id=' + encodeURIComponent(event_id) + '&token=abc';

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  getevents(done, notFound, fail) {
    var url = this.apiBase +
      'events/';

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
		console.log(data);
		done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }
  
  sortorder(data, done, notFound, fail) {
    var url = this.apiBase +
      'sortorder/?event_id=' + encodeURIComponent(data.event_id);

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  results(data, done, notFound, fail) {
    var url = this.apiBase +
      'results/?event_id=' + encodeURIComponent(data.event_id);

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  resultsbyclub(data, done, notFound, fail) {
    var url = this.apiBase +
      'results/?event_id=' + encodeURIComponent(data.event_id) + '&club=' + encodeURIComponent(data.club);

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  resultsbycategory(data, done, notFound, fail) {
    var url = this.apiBase +
      'results/?event_id=' + encodeURIComponent(data.event_id) + '&category=' + encodeURIComponent(data.category);

    $.ajax({
      url: url,
      timeout: this.standardTimeout
    }).done(function(data) {
      done(data);
    }).fail(function(xhr) {
      if (xhr.status === 404) {
        notFound();
      } else {
        fail();
      }
    });
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }
  
  accessHeaders() {
    return {
		"Accept": "application/json", "Content-Type": "application/json"
    };
  }

}

export default API;
